
/***** Select *****/
// Clic sur les selects
$(document).on('click', '.select-list button.select-list-button', function(e) {
	e.preventDefault();

	var $ul = $(this).siblings('ul');
	var $button = $($ul).siblings('.select-list-button').find('svg');
	$ul.toggleClass('active');
	$button.css({'transform':'translateY(-50%)'});
	// on cache tous les select pour afficher uniquement le bon
	$('.select-list').find('ul').addClass('hide');
	
	if ($ul.hasClass('active')) {
		$ul.removeClass('hide');
		$button.css({'transform':'translateY(-50%) rotateZ(180deg)'});
	}
	
	var $choices = $(this).parent('.select-list');
	$choices.css('left', '0'); // par défaut : full screen
	$choices.show();

	// on vérifie la taille de l'écran pour positionner le select
	if ($choices.is(':visible')) {
		var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		var offset = $choices.offset();
		var posRight = offset.left + $choices.outerWidth();

		if (posRight > windowWidth) {
			var position = windowWidth - posRight - 12;
			$choices.css('left', position);
		}
	}
});

$(document).on('change', '.select-list > input', function() {
	hideErrors($(this).parents('.input-container'));
});

// Fermeture des selects
$(document).click(function(event) {
	if (!$(event.target).closest('.select-list').length) {
		$('.select-list').each(function() {
			if ($(this).find('ul').is(':visible')) {
				$(this).find('ul').addClass('hide');
				$(this).find('ul').removeClass('active');
				$(this).find('.select-list-button').children('svg').css({'transform':'translateY(-50%)'});
			}
		});
	}
});

// Sélection d'un item des selects
$(document).on('click', '.select-list ul li.value', function() {
	var $select = $(this).parents('.select-list');
	if($select) selectListItem($select, $(this))
	$($select).find('.select-list-button').children('svg').css({'transform':'translateY(-50%)'});
});

function selectListItem($list, $li, change) {
	if(typeof change == 'undefined') change = true
	$list.find('button.select-list-button .text').val($li.text())
	$list.find('input[type=hidden]').val($li.data('value'))
	if(change) $list.find('input[type=hidden]').change()

	// Ajoute les datas du li dans l'input hidden pour garder les informations
	if($li.length) {
		var reg = /^data\-(.+)$/;
		$.each($li[0].attributes, function(index, attr) {
			if (reg.test(attr.nodeName)) {
				$list.find('input[type=hidden]').data(attr.nodeName.match(reg)[1], attr.nodeValue);
			}
		});
	}
	$list.find('ul').addClass('hide');
	$list.find('ul').removeClass('active');
}

(function(window) {
	window.Select = {
		get_visible_input: function($elem) {
			return $elem.closest('.select-list').children('[class^="icon-"]').add($elem.closest('.select-list').find('button.select-list-button .text'));
		},
		is_invalid: function($elem) {
			this.get_visible_input($elem).addClass('is-invalid-input');
		},
		is_valid: function($elem) {
			this.get_visible_input($elem).removeClass('is-invalid-input');
		}
	}
})(window);	

